import { useContext } from 'react';
import { ChatContext, type ChatContextValue } from '@/contexts/chatContextObj';

/** AI チャットパネルの開閉。ChatProvider（MainLayout）の外では null */
export function useChat(): ChatContextValue | null {
  return useContext(ChatContext);
}
